import { createContext } from 'react';

import { JsonWebToken } from 'services/core/lib/auth/AuthService';

interface ExternalWasteManagementAuthContextValue {
	authenticate(password: string): Promise<boolean>;

	invalidate(): Promise<void>;

	authError(): string | null;

	setAuthError(message: string | null): void;

	jsonWebToken(): JsonWebToken | null;
}

export const ExternalWasteManagementReportAuthContext = createContext<ExternalWasteManagementAuthContextValue>({
	authenticate: async (): Promise<boolean> => {
		return false;
	},

	invalidate: async (): Promise<void> => {
	},

	authError(): string | null {
		return null;
	},

	setAuthError(): void {
	},

	jsonWebToken(): JsonWebToken | null {
		return null;
	}
});
